import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { HomeHero } from '../components/home/HomeHero';
import { HomeApproach } from '../components/home/HomeApproach';
import { HomeServices } from '../components/home/HomeServices';
import { HomeBoardSearch } from '../components/home/HomeBoardSearch';
import { HomeProcess } from '../components/home/HomeProcess';
import { HomeTeam } from '../components/home/HomeTeam';
import { CallToAction } from '../components/ui/CallToAction';
export function Home() {
  usePageMeta('Avenqor Talent Search | Executive Search & Talent Advisory', 'Avenqor Talent Search connects organizations with senior executives, board members and specialized professionals through research-led, discreet executive search.');
  return <>
      <HomeHero data-id="element-499" data-mp="3kvk3cdh3kp2t" />
      <HomeApproach data-id="element-500" data-mp="3kw1y15o42v8m" />
      <HomeServices data-id="element-501" data-mp="3kuqvtaabdvjm" />
      <HomeBoardSearch data-id="element-502" data-mp="3kxd3rb14ad2d" />
      <HomeProcess data-id="element-503" data-mp="3owvpua4ocu6s" />
      <HomeTeam data-id="element-504" data-mp="3ow437ot226sn" />
      <CallToAction data-id="element-505" data-mp="3ovkjq3nrbaci" />
    </>;
}